import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GiftDetail } from 'src/app/_models/giftDetail';
import { GiftingService } from 'src/app/_services/gifting.service';
import { ImageService } from 'src/app/_services/image.service';

@Component({
  selector: 'app-gift-detail-edit',
  templateUrl: './gift-detail-edit.component.html',
  styleUrls: ['./gift-detail-edit.component.css']
})
export class GiftDetailEditComponent implements OnInit {

  server_gift_detail_id:number=0
  myForm: FormGroup;
  loading = false;
  errorMessage = '';
  errorEncountered=false
  isLoggedIn = false;
  isSaving=false
  giftDetail:GiftDetail = new GiftDetail()
  giftCategories=[]
  server_gift_detail_id_nxt:number=0
  server_gift_detail_id_prev:number=0
  imageSource:any=undefined
  imageLoading=false

  constructor(
      private router: Router,
      private activeRoute:ActivatedRoute,
      private giftService:GiftingService,
      private imageService :ImageService) {}

  ngOnInit() {
     this.activeRoute.params.subscribe(
      x=>{
       this.server_gift_detail_id =  +x['server_gift_detail_id']
       this.server_gift_detail_id_nxt=this.server_gift_detail_id + 1
       this.server_gift_detail_id_prev=this.server_gift_detail_id -1
       if(this.server_gift_detail_id==0){
        this.initMainFormFresh()
       }else{
        this.giftService.getGiftDetail(this.server_gift_detail_id).subscribe(
          data=>{
            this.initMainFormUpdate(data)
            this.giftDetail=data
            this.showGiftImage()
          }
        )
       }
      }
     )
     this.loadEducationSystems()
  }

  // convenience getter for easy access to form fields
  get f() { return this.myForm.controls; }

  on_submit(): void {

        // stop here if form is invalid
        if (this.myForm.invalid) {
            return;
        }

        this.isSaving = true;
        this.errorEncountered=false
        let giftDetailItem = new GiftDetail()
        giftDetailItem.id =this.server_gift_detail_id
        giftDetailItem.name = this.myForm.value.name
        giftDetailItem.description = this.myForm.value.description
        giftDetailItem.server_gift_category_id = this.myForm.value.giftCategory

        if(this.server_gift_detail_id==0){
          this.saveNew(giftDetailItem)
        }else{
          this.updateExisting(giftDetailItem)
        }
      }

  saveNew(syllabusItem:GiftDetail){
    this.giftService.newGiftDetail(syllabusItem).subscribe(
      data=>{
        this.isSaving=false
        this.router.navigate(['admin/gifts'])
      },
      err=>{
        this.isSaving=false
        this.errorMessage = err.error.message;
        this.errorEncountered=true
      }
    )
  }
  updateExisting(syllabusItem:GiftDetail){
    this.giftService.editGiftDetail(syllabusItem).subscribe(
      data=>{
        this.isSaving=false
        this.router.navigate(['admin/gifts'])
      },
      err=>{
        this.isSaving=false
        this.errorMessage = err.error.message;
        this.errorEncountered=true
      }
    )
  }
  initMainFormUpdate(xxx:any){
    this.myForm=new FormGroup({
      name: new FormControl(xxx['name'], Validators.compose([Validators.required,Validators.minLength(3)])),
      giftCategory: new FormControl(xxx['server_gift_category_id']),
      description: new FormControl(xxx['description'])
    });
  }
  initMainFormFresh(){
    this.myForm=new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required,Validators.minLength(3)])),
      giftCategory: new FormControl(7,Validators.required),
      description: new FormControl("")
    });
  }


  loadEducationSystems(){
    this.giftService.getCategories().subscribe(
      x=>{
        this.giftCategories=x
        this.loading=false
      }
    )
    }

    showGiftImage(){
        this.imageSource=undefined
        this.imageLoading=true
        this.imageService.showGiftImage(this.giftDetail.name).subscribe(
          iValue =>{
            this.imageLoading=false
           this.imageSource =  "<img src=data:image/png;base64,"+iValue+">"
          }
        )

      }
}
